module.exports = __webpack_public_path__ + "img/ball2_db.ac6fdbab.png";